// Généré par maquettes/outils/dc2react.py à partir de maquettes/src/4_script.js.
import React from 'react';
import HomeView from './HomeView';
import { startAutopilot } from './autopilot';
import './home.css';

class HomeLogic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 'stock',
      view: 'after',
      t: 1,
      inView: false,
      videoPaused: false,
      compareOpen: false,
      supplier: null,
      marginMode: 'shown',
      product: 4,
      propagated: 0,
      propagating: false,
      chatQ: 0,
      chatWords: 999,
      faqOpen: -1
    };
    this.setSection = (el) => { this.sectionEl = el; };
    this.setVideo = (el) => {
      if (el && el !== this.videoEl) {
        el.setAttribute('muted', '');
        el.muted = true;
        el.addEventListener('play', () => this.setState({ videoPaused: false }));
        el.addEventListener('pause', () => this.setState({ videoPaused: true }));
      }
      this.videoEl = el;
    };
    this.toggleVideo = () => {
      const v = this.videoEl;
      if (!v) return;
      this.userPaused = !v.paused;
      if (v.paused) v.play().catch(() => {});
      else v.pause();
    };
    this.questions = [
      "Quels produits nous font perdre de l'argent ce mois-ci, tous canaux confondus ?",
      "Et si on fabrique la Veste Altitude à Porto plutôt qu'à Annecy ?"
    ];
    this.answers = [
      "Un seul : Gants Arête, −445 € sur 30 jours sur Amazon. La pub coûte 8,82 € par paire vendue, et « taille petit » revient dans 12 avis. Je propose de couper la campagne Amazon FR et de corriger le guide des tailles.",
      "Arrivée le 19 novembre au lieu du 26 octobre : 22 jours de rupture en pleine saison, soit environ 17 400 € de marge perdue pour 2 700 € économisés."
    ];
    this.sheets = {
      stock: {
        files: ['prod_hiver_v7_FINAL(2).xlsx', 'ventes_boutiques_0310.csv', 'precommandes_revendeurs.xlsx'],
        formula: "=SI(ESTNA(RECHERCHEV(A2;'Stock FBA'!A:F;5;0));\"?\";C2*1,2-B2)",
        rows: [
          ['Modèle', 'Stock', 'Ventes / mois', 'Délai', 'À lancer ?', 'Commentaire'],
          ['Veste Altitude M', '420', '%540 ?', '45 j', '!#N/A', '^rupture ?? voir Léa'],
          ['Polaire Crête', '900', '—', '45 j', '800', '^tissu reçu ?'],
          ['Bonnet Névé', '1300', '650', '30', '', ''],
          ['Short Lagon', '2300', '270', '45', '^1000', '^série de l\'été ?'],
          ['Gants Arête', '150', '180', '21 j', '!#REF!', ''],
          ['TOTAL', '%=SOMME(B2:B6)', '', '', '', '']
        ],
        note: "Hugo : j'ai repris le fichier de Léa. Les ventes datent de septembre, je crois.",
        footer: 'prod_hiver_v7_FINAL(2).xlsx · modifié par Hugo il y a 9 jours · 3 copies sur le Drive'
      },
      finance: {
        files: ['marge_sept_v3.xlsx', 'export_seller_central.csv', 'caisse_boutiques_sept.csv'],
        formula: "='export_seller_central'!F2/'export_seller_central'!C2",
        rows: [
          ['Canal', 'CA sept.', 'Marge affichée', 'Marge compta', 'Écart', 'Commentaire'],
          ['Amazon', '389 200', '31 %', '%14 % ?', '!17 pts', '^pourquoi ???'],
          ['Site', '87 600', '46 %', '—', '!#DIV/0!', ''],
          ['Boutiques', '64 300', '%44 % caisse', '%?', '', '^sans les remises ?'],
          ['Revendeurs', '35 600', '%?', '%?', '', '^demander à la compta'],
                    ['Facture Porto #4471', '15 060', '', '', '', '%payée'],
          ['TOTAL', '!#VALEUR!', '', '', '', '']
        ],
        note: "Direction : on a quelle marge au final ? J'ai besoin du chiffre pour la banque.",
        footer: 'marge_sept_v3.xlsx · 4 h de compilation ce lundi · 3 sources qui ne se parlent pas'
      },
      ventes: {
        files: ['export_pub_0310.csv', 'avis_clients_sept.xlsx'],
        formula: '=B3/C3',
        rows: [
          ['Campagne', 'Dépense', 'Ventes', 'ACOS', 'Marge ?', 'Décision'],
          ['SP_Veste_Auto', '3 850', '48 060', '8,0 %', '', ''],
          ['SP_Gants_Arete', '1 320', '6 300', '21,0 %', '%?', '^on garde ?'],
          ['SP_Bonnet_IT', '2 260', '12 540', '18,0 %', '%?', ''],
          ['SB_Short_DE', '1 100', '7 830', '14,0 %', '%?', ''],
          ['Meta_Polaire', '3 780', '31 500', '12,0 %', '%?', '%autre export'],
          ['Notes clients', '%→ autre fichier', '', '', '', '']
        ],
        note: "Inès : la marge est dans le fichier de la compta, je crois. Je regarde lundi.",
        footer: 'export_pub_0310.csv · aucune colonne marge · notes clients dans un autre fichier'
      },
      ops: {
        files: ['prix_canaux_MAJ.xlsx', 'fiches_produit_FR.docx'],
        formula: '44,90 (nouveau prix Polaire Crête, à reporter partout)',
        rows: [
          ['Modèle', 'Site', 'Amazon FR', 'Boutiques', 'Revendeurs', 'MAJ faite ?'],
          ['Veste Altitude', '89,00', '89,00', '89,00', '71,20', 'oui'],
          ['Polaire Crête', '44,90', '44,90', '%42,00 ?', '33,60', '^à faire'],
          ['Bonnet Névé', '19,00', '19,00', '19,00', '!tarif ??', '^grille 2025 ?'],
          ['Gants Arête', '35,00', '!désactivé ??', '35,00', '28,00', ''],
          ['Short Lagon', '29,00', '29,00', '29,00', '23,20', 'oui'],
          ['', '', '', '', '', '']
        ],
        note: "Hugo : j'ai fait le site et Amazon FR. Il reste DE, Zalando, la caisse des boutiques et le tarif revendeurs.",
        footer: 'prix_canaux_MAJ.xlsx · 6 back-offices à mettre à jour à la main'
      }
    };
  }

  componentDidMount() {
    if (!window.__PRERENDER__) this.stopAutopilot = startAutopilot();
    if (window.__PRERENDER__) return;
    const v = this.videoEl;
    if (v) {
      v.muted = true;
      const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) v.pause();
      else v.play().catch(() => {});
      this.setState({ videoPaused: v.paused });
      // Un onglet masqué met la vidéo en pause : on la relance au retour, sauf si le visiteur l'a arrêtée.
      this.onVisible = () => {
        if (!document.hidden && !reduced && !this.userPaused && this.videoEl && this.videoEl.paused) this.videoEl.play().catch(() => {});
      };
      document.addEventListener('visibilitychange', this.onVisible);
    }
    const el = this.sectionEl;
    if (el && typeof IntersectionObserver !== 'undefined') {
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          this.io.disconnect();
          this.setState({ inView: true });
          this.countUp();
        }
      }, { threshold: 0.15 });
      this.io.observe(el);
    } else {
      this.setState({ inView: true });
      this.countUp();
    }
  }

  componentWillUnmount() {
    if (this.stopAutopilot) this.stopAutopilot();
    clearInterval(this.propTimer);
    clearInterval(this.chatTimer);
    clearInterval(this.countTimer);
    if (this.onVisible) document.removeEventListener('visibilitychange', this.onVisible);
    if (this.io) this.io.disconnect();
  }

  countUp() {
    clearInterval(this.countTimer);
    let step = 0;
    const N = 24;
    this.setState({ t: 0 });
    this.countTimer = setInterval(() => {
      step += 1;
      if (step >= N) {
        clearInterval(this.countTimer);
        this.setState({ t: 1 });
      } else {
        const x = step / N;
        this.setState({ t: 1 - Math.pow(1 - x, 3) });
      }
    }, 32);
  }

  goTab(id) {
    this.setState({ tab: id, view: 'after' });
    if (this.state.inView) this.countUp();
  }

  startProp() {
    clearInterval(this.propTimer);
    this.setState({ propagated: 0, propagating: true });
    this.propTimer = setInterval(() => {
      const n = this.state.propagated + 1;
      if (n >= 6) {
        clearInterval(this.propTimer);
        this.setState({ propagated: 6, propagating: false });
      } else {
        this.setState({ propagated: n });
      }
    }, 420);
  }

  ask(i) {
    clearInterval(this.chatTimer);
    const total = this.answers[i].split(' ').length;
    this.setState({ chatQ: i, chatWords: 0 });
    this.chatTimer = setInterval(() => {
      const n = this.state.chatWords + 1;
      if (n >= total) {
        clearInterval(this.chatTimer);
        this.setState({ chatWords: total });
      } else {
        this.setState({ chatWords: n });
      }
    }, 70);
  }

  renderVals() {
    const s = this.state;
    const accent = this.props.accent ?? '#2347D6';
    const orange = '#C2410C';
    const t = s.t;
    const eur = (n) => Math.round(n).toLocaleString('fr-FR') + ' €';
    const fmt = (n) => (n < 0 ? '−' : '') + Math.abs(n).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    const kpi = (label, val, alert) => ({ label: label, val: val, color: alert ? orange : '#15171A' });

    const tabOn = (on) => on
      ? { bg: '#FFFFFF', fg: '#15171A', w: '700', sh: 'inset 0 3px 0 ' + accent }
      : { bg: 'transparent', fg: '#4A5059', w: '500', sh: 'none' };
    const navOn = (on) => on
      ? { bg: '#EEF2FF', fg: accent, w: '600' }
      : { bg: 'transparent', fg: '#30353C', w: '500' };
    const segOn = (on, dark) => on
      ? { bg: dark || '#FFFFFF', fg: dark ? '#FFFFFF' : '#15171A', sh: '0 1px 2px rgba(21, 23, 26, 0.18)' }
      : { bg: 'transparent', fg: '#4A5059', sh: 'none' };

    const isReal = s.marginMode === 'real';
    const fin = [
      { label: 'Amazon', shown: 31, real: 17.2 },
      { label: 'Site', shown: 46, real: 24.9 },
      { label: 'Boutiques', shown: 44, real: 21.3 },
      { label: 'Revendeurs', shown: null, real: 15.1 },
      { label: 'Total', shown: null, real: 18.4 }
    ];
    const finBars = fin.map((r) => {
      const v = isReal ? r.real : r.shown;
      return {
        label: r.label,
        weight: r.label === 'Total' ? '700' : '500',
        w: v === null ? '0%' : (v * 2) + '%',
        color: isReal ? (r.label === 'Total' ? '#15171A' : accent) : '#9AA1AA',
        txt: v === null ? 'aucun outil' : v.toLocaleString('fr-FR') + ' %',
        txtColor: v === null ? '#5A6068' : '#15171A'
      };
    });

    const P = [
      // Prix hors taxes ; commission et pub calculées sur le prix TTC (× 1,2), comme sur Amazon et dans
      // le calculateur de marge. La Veste Altitude est l'exemple du calculateur, au centime près.
      { name: 'Polaire Crête', x: 12, y: 35.1, ca: 31500, labelTop: '-18px', tone: 'ok', price: 42, steps: [['Frais de paiement', -1.01], ['Logistique et livraison', -7.2], ['Coût de revient', -11], ['Retours', -1.68], ['Stockage', -0.3], ['Pub', -6.05]] },
      { name: 'Veste Altitude', x: 8, y: 34.5, ca: 48060, labelTop: '40px', tone: 'ok', price: 89, steps: [['Commission', -16.02], ['Frais FBA', -7.9], ['Coût de revient', -24.2], ['Retours', -1.2], ['Stockage', -0.4], ['Pub', -8.54]] },
      { name: 'Bonnet Névé', x: 18, y: 9.8, ca: 12540, labelTop: '40px', tone: 'warn', price: 19, steps: [['Commission', -3.42], ['Frais FBA', -3.9], ['Coût de revient', -5], ['Retours', -0.57], ['Stockage', -0.15], ['Pub', -4.1]] },
      { name: 'Short Lagon', x: 14, y: 8.4, ca: 7830, labelTop: '-18px', tone: 'warn', price: 29, steps: [['Commission', -5.22], ['Frais FBA', -5.1], ['Coût de revient', -9], ['Retours', -1.16], ['Stockage', -1.2], ['Pub', -4.87]] },
      { name: 'Gants Arête', x: 21, y: -8.5, ca: 5240, labelTop: '-18px', tone: 'alert', price: 35, steps: [['Commission', -6.3], ['Frais FBA', -6.2], ['Coût de revient', -13], ['Retours (tailles)', -3.5], ['Stockage', -0.17], ['Pub', -8.82]] }
    ];
    const bubbles = P.map((p, i) => {
      const sel = i === s.product;
      const alert = p.tone === 'alert';
      return {
        name: p.name,
        left: (p.x / 25 * 100).toFixed(1) + '%',
        bottom: ((p.y + 10) / 55 * 100).toFixed(1) + '%',
        size: Math.round(14 + Math.sqrt(p.ca / 1000) * 3.8) + 'px',
        fill: sel ? (alert ? orange : accent) : (alert ? '#F2B79A' : '#B9C6F6'),
        ring: sel ? (alert ? '0 0 0 5px rgba(194, 65, 12, 0.18)' : '0 0 0 5px rgba(35, 71, 214, 0.18)') : 'none',
        w: sel ? '700' : '500',
        sel: sel,
        aria: p.name + ' : pub ' + p.x + ' % des ventes, marge ' + p.y.toLocaleString('fr-FR') + ' %',
        delay: (i * 110) + 'ms',
        labelTop: p.labelTop,
        demo: 'b-' + p.name.split(' ')[0].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
        pick: () => this.setState({ product: i })
      };
    });
    const sp = P[s.product];
    let remaining = sp.price;
    const cascade = [{ label: 'Prix de vente HT', val: fmt(sp.price), w: '100%', color: '#15171A' }];
    sp.steps.forEach((st) => {
      remaining = Math.round((remaining + st[1]) * 100) / 100;
      cascade.push({ label: st[0], val: fmt(st[1]), w: (Math.abs(st[1]) / sp.price * 100).toFixed(1) + '%', color: st[0] === 'Pub' ? '#E08A5C' : '#9AA1AA' });
    });

    const channels = ['Site', 'Amazon FR', 'Amazon DE', 'Zalando', 'Boutiques', 'Revendeurs'];
    const oldPrices = ['42,00 €', '39,90 €', '39,90 €', '39,90 €', '42,00 €', '33,60 €'];
    const newPrices = ['44,90 €', '44,90 €', '44,90 €', '44,90 €', '44,90 €', '35,92 €'];
    const propDone = s.propagated >= 6;
    const chips = channels.map((c, i) => {
      const done = i < s.propagated;
      const busy = s.propagating && i === s.propagated;
      return {
        name: c,
        price: done ? newPrices[i] : oldPrices[i],
        status: done ? 'à jour' : (busy ? 'envoi…' : 'en attente'),
        bg: done ? '#F1F4FF' : '#FFFFFF',
        border: done ? accent : (busy ? '#15171A' : '#E3E5E8'),
        fg: done ? accent : '#30353C',
        bar: done ? '100%' : (busy ? '55%' : '0%')
      };
    });
    const G = [
      ['Veste Altitude', ['ok', 'ok', 'ok', 'ok', 'ok', 'ok']],
      ['Polaire Crête', ['warn', 'ok', 'ok', 'ok', 'warn', 'ok']],
      ['Bonnet Névé', ['ok', 'ok', 'ok', 'ok', 'ok', 'warn']],
      ['Short Lagon', ['ok', 'ok', 'ok', 'ok', 'ok', 'ok']],
      ['Gants Arête', ['ok', 'ok', 'alert', 'ok', 'ok', 'ok']]
    ];
    const gridRows = G.map((row) => {
      const out = { name: row[0] };
      row[1].forEach((st, j) => {
        const tt = (row[0] === 'Polaire Crête' && propDone) ? 'ok' : st;
        out['c' + j] = {
          label: channels[j] + ' : ' + (tt === 'ok' ? 'à jour' : (tt === 'warn' ? 'à vérifier' : 'désactivée')),
          size: tt === 'ok' ? '10px' : '13px',
          bg: tt === 'ok' ? '#B8BEC6' : (tt === 'alert' ? orange : 'transparent'),
          border: tt === 'warn' ? '2px solid ' + orange : '0',
          anim: tt === 'alert' ? 'ping 2s ease-in-out infinite' : 'none'
        };
      });
      return out;
    });

    const toastDefs = [
      { id: 'stock', title: 'Rupture prévue · Veste Altitude', text: 'Le 28 octobre, en pleine saison, sur le M et le L. La fabriquer à Annecy l’évite.', color: orange },
      { id: 'finance', title: 'Écart détecté · facture Porto #4471', text: '600 vestes facturées, 580 reçues : 502 € à réclamer.', color: orange },
      { id: 'ventes', title: 'Campagne à couper · Gants Arête', text: '1 320 € de pub par mois pour −445 € de marge.', color: orange },
      { id: 'ops', title: 'Annonce désactivée · Gants Arête', text: 'Amazon DE : numéro REP emballages manquant.', color: orange },
      { id: 'opsDone', title: 'Prix mis à jour sur 6 canaux', text: 'Polaire Crête à 44,90 € partout. Tarif revendeurs recalculé.', color: accent }
    ];
    const activeToast = s.tab === 'ops' && propDone ? 'opsDone' : s.tab;
    const toasts = toastDefs.map((d) => ({ on: d.id === activeToast, title: d.title, text: d.text, color: d.color }));

    const copy = [
      { id: 'stock', pain: 'Rupture sur le best-seller, six mois de stock sur le reste.', gain: 'Quoi fabriquer ou commander, combien et quand, taille par taille.' },
      { id: 'finance', pain: 'Trois outils, trois marges différentes pour le même mois.', gain: 'Une seule marge, rapprochée des virements et des factures.' },
      { id: 'ventes', pain: 'La pub d\u2019un produit se pilote au feeling.', gain: 'Ce que coûte la pub, ce qu\u2019il reste, et quoi couper.' },
      { id: 'ops', pain: 'Un prix change : six back-offices à mettre à jour.', gain: 'Une fiche par produit, la même pour tous vos canaux.' }
    ];
    const tabCopy = copy.map((c) => Object.assign({ on: c.id === s.tab }, c));

    const faqData = [
      ['Mes données sont-elles en sécurité ?', 'Avant le premier fichier, on signe un accord de confidentialité et un contrat de sous-traitance RGPD. Je travaille avec des accès en lecture seule, que vous créez et retirez vous-même : l\u2019écriture n\u2019est demandée que si l\u2019outil modifie vos annonces, et le devis le précise. L\u2019outil et la base sont hébergés en Europe, sur un compte à votre nom, et chacun n\u2019y voit que ce qui le concerne. L\u2019IA est une option : si vous l\u2019activez, elle passe par votre compte professionnel Claude ou ChatGPT, qui n\u2019entraîne pas ses modèles sur vos données, et ne lit que ce que votre rôle autorise. Sans votre accord, rien ne part vers une IA. En fin de mission, je supprime mes copies et je vous le confirme par écrit.'],
      ['J\u2019ai déjà Sellerboard, Prediko ou un outil d\u2019analytics. Pourquoi vous ?', 'Gardez-les. Je construis ce qu\u2019ils ne font pas : la marge sur tous vos canaux à la fois, vos règles de coût, le rapprochement avec la compta. Et je les relie entre eux.'],
      ['On a déjà un ERP. Vous le remplacez ?', 'Non, je me branche dessus. Odoo, Sage, Cegid, votre caisse, Shopify, PrestaShop ou WooCommerce : votre ERP reste la référence pour les commandes et la compta. L\u2019outil y lit ce dont il a besoin pour faire ce que l\u2019ERP ne fait pas, comme le réappro multicanal, la planification de la production ou la marge par canal.'],
      ['Amazon et Shopify ont leurs assistants IA. Ça ne suffit pas ?', 'Chaque plateforme ne voit que ses propres données : ni vos coûts fournisseurs, ni vos autres canaux, ni votre compta. Je construis la couche qui manque, puis je la branche sur votre IA.'],
      ['Combien ça coûte ?', 'Tout est sur mesure. Un outil : à partir de 2 900 € HT. Votre système, plusieurs outils sur la même base : à partir de 7 500 € HT. La formation de votre équipe : 900 € HT la demi-journée, incluse dans votre système. Le prix est fixé par écrit avant de commencer, et se paie en deux fois : 50 % au démarrage, 50 % quand votre équipe a validé l\u2019outil.'],
      ['Et une fois l\u2019outil livré ?', 'Les corrections sont incluses pendant 30 jours, 60 pour votre système. Ensuite, l\u2019outil reste à vous. Sans suivi, il tourne tant qu\u2019Amazon et Shopify ne changent pas leurs formats ; s\u2019ils changent, je corrige sur devis. Le suivi, de 300 à 600 € HT par mois selon le nombre de sources branchées, couvre ces changements et les petites évolutions, sans engagement. L\u2019hébergement est à votre nom : son coût, en général quelques dizaines d\u2019euros par mois, est indiqué dans le devis. Et pour ajouter un outil, on repart de la même base : vous ne payez que ce qui s\u2019ajoute.'],
      ['Mon équipe n\u2019est pas technique. Saura-t-elle s\u2019en servir ?', 'Oui. Chaque outil est livré avec une prise en main sur vos propres données. La formation va plus loin : une demi-journée de montée en compétences sur les outils d\u2019IA, appliquée à vos propres chiffres, pour que l\u2019équipe interroge ses données avec Claude ou ChatGPT et sache vérifier les réponses. Elle est incluse dans votre système, et existe aussi seule, à 900 € HT : vous ne dépendez pas de moi pour chaque question.'],
      ['Faudra-t-il encore exporter des fichiers chaque semaine ?', 'Non. Amazon et Shopify se connectent directement à la base : ventes, stock et frais arrivent seuls. Pour le reste (fournisseurs, revendeurs, compta), je me branche sur votre logiciel quand c\u2019est possible, sinon je reprends vos Excel tels qu\u2019ils sont.'],
      ['On n\u2019a que des Excel. Par où on commence ?', 'Par eux. Je reprends vos fichiers tels qu\u2019ils sont, je les nettoie et je les range dans une seule base. Vos outils se construisent dessus, et personne n\u2019a besoin d\u2019équipe technique.'],
      ['À qui appartient le code ?', 'À vous : code, données et documentation. N\u2019importe quel développeur, ou votre équipe avec ses outils d\u2019IA, peut le faire évoluer.'],
      ['Et si vous n\u2019êtes plus disponible ?', 'L\u2019outil ne dépend pas de moi. Le code, la base et la documentation sont à vous, hébergés sur un compte à votre nom. N\u2019importe quel développeur, ou votre équipe avec ses outils d\u2019IA, peut reprendre là où je m\u2019arrête, et le suivi mensuel est sans engagement.']
    ];
    const faq = faqData.map((f, i) => ({
      q: f[0], a: f[1], open: s.faqOpen === i, icon: s.faqOpen === i ? '−' : '+',
      toggle: () => this.setState({ faqOpen: this.state.faqOpen === i ? -1 : i })
    }));

    const sh = this.sheets[s.tab];
    const cell = (raw, header) => {
      let v = raw, bg = header ? '#F1F2F4' : '#FFFFFF', fg = '#15171A', w = header ? '700' : '400', st = 'normal';
      const m = raw.charAt(0);
      if (m === '!') { v = raw.slice(1); fg = orange; w = '600'; }
      else if (m === '^') { v = raw.slice(1); bg = '#FFF3B0'; }
      else if (m === '%') { v = raw.slice(1); fg = '#5A6068'; st = 'italic'; }
      return { v: v, bg: bg, fg: fg, w: w, st: st };
    };
    const sheetRows = sh.rows.map((r, i) => {
      const o = { n: String(i + 1) };
      r.forEach((c, j) => { o['c' + j] = cell(c, i === 0); });
      return o;
    });
    const sheetFiles = sh.files.map((f, i) => ({ name: f, bg: i === 0 ? '#FFFFFF' : 'transparent', fg: i === 0 ? '#15171A' : '#4A5059' }));

    const words = this.answers[s.chatQ].split(' ');
    const shown = Math.min(s.chatWords, words.length);
    const chatTyping = shown < words.length;

    return Object.assign({
      accent: accent,
      setSection: this.setSection,
      inView: s.inView,

      setVideo: this.setVideo,
      toggleVideo: this.toggleVideo,
      videoPlaying: !s.videoPaused, videoPaused: s.videoPaused,
      videoLabel: s.videoPaused ? 'Lire la vidéo de démonstration' : 'Mettre en pause la vidéo de démonstration',
      tab: s.tab,
      tabCopy: tabCopy,
      faq: faq,

      isStock: s.tab === 'stock', isFinance: s.tab === 'finance', isVentes: s.tab === 'ventes', isOps: s.tab === 'ops',
      goStock: () => this.goTab('stock'),
      goFinance: () => this.goTab('finance'),
      goVentes: () => this.goTab('ventes'),
      goOps: () => this.goTab('ops'),
      tabS: tabOn(s.tab === 'stock'), tabF: tabOn(s.tab === 'finance'), tabV: tabOn(s.tab === 'ventes'), tabO: tabOn(s.tab === 'ops'),
      navS: navOn(s.tab === 'stock'), navF: navOn(s.tab === 'finance'), navV: navOn(s.tab === 'ventes'), navO: navOn(s.tab === 'ops'),

      isAfter: s.view === 'after', isBefore: s.view === 'before',
      vAfter: segOn(s.view === 'after'), vBefore: segOn(s.view === 'before'),
      showBefore: () => this.setState({ view: 'before' }),
      showAfter: () => { this.setState({ view: 'after' }); this.countUp(); },

      kStock: [
        kpi('CA menacé par les ruptures (90 j)', eur(49000 * t), true),
        kpi('Trésorerie dormante en surstock', eur(38200 * t)),
        kpi('Fabrications à lancer sous 15 jours', String(Math.round(2 * t))),
        kpi('Justesse de la prévision (30 j)', Math.round(91 * t) + ' %')
      ],
      kFin: [
        kpi('Marge réelle · septembre', (18.4 * t).toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %'),
        kpi('Virements rapprochés', eur(229380 * t)),
        kpi('Factures rapprochées', Math.round(14 * t) + ' / 15'),
        kpi('À réclamer aux fournisseurs', eur(502 * t), true)
      ],
      kVentes: [
        kpi('CA · 30 jours', eur(512400 * t)),
        kpi('Pub · 11,5 % des ventes', eur(58900 * t)),
        kpi('Marge nette · 18,4 %', eur(94100 * t)),
        kpi('Pub sur produits non rentables', eur(6300 * t) + '/mois', true)
      ],
      kOps: [
        kpi('Annonces surveillées', String(Math.round(30 * t))),
        kpi('À corriger ce matin', String(Math.round((propDone ? 2 : 3) * t)), true),
        kpi('Modifications ce mois', String(Math.round(214 * t))),
        kpi('Erreurs de synchronisation', '0')
      ],

      compareOpen: s.compareOpen, compareClosed: !s.compareOpen,
      openCompare: () => this.setState({ compareOpen: true }),
      closeCompare: () => this.setState({ compareOpen: false, supplier: null }),
      pickA: () => this.setState({ supplier: 'A' }),
      pickB: () => this.setState({ supplier: 'B' }),
      supA: s.supplier === 'A', supB: s.supplier === 'B', supNone: s.supplier === null,
      supABorder: s.supplier === 'A' ? orange : '#CDD1D6',
      supBBorder: s.supplier === 'B' ? accent : '#CDD1D6',

      isReal: isReal, isShown: !isReal,
      setReal: () => this.setState({ marginMode: 'real' }),
      setShown: () => this.setState({ marginMode: 'shown' }),
      mReal: segOn(isReal, accent), mShown: segOn(!isReal, '#15171A'),
      finBars: finBars,
      finCaption: isReal
        ? 'Un seul calcul, rapproché des virements, de la caisse et des factures : 18,4 % pour tout le monde.'
        : 'Seller Central, Shopify et la caisse ne comptent ni la pub, ni les retours, ni le coût de revient. Et personne ne mesure les revendeurs.',

      bubbles: bubbles,
      selName: sp.name,
      cascade: cascade,
      marginVal: fmt(remaining),
      marginW: (Math.abs(remaining) / sp.price * 100).toFixed(1) + '%',
      marginColor: remaining < 0 ? orange : accent,

      gridRows: gridRows,
      plaidAlert: !propDone,
      chips: chips,
      propIdle: s.propagated === 0 && !s.propagating,
      propDone: propDone,
      startProp: () => this.startProp(),
      resetProp: () => { clearInterval(this.propTimer); this.setState({ propagated: 0, propagating: false }); },

      toasts: toasts,

      sheetFiles: sheetFiles,
      sheetFormula: sh.formula,
      sheetRows: sheetRows,
      sheetNote: sh.note,
      sheetFooter: sh.footer,

      chatQuestion: this.questions[s.chatQ],
      chatAnswer: words.slice(0, shown).join(' '),
      chatTyping: chatTyping,
      chatDone: !chatTyping,
      q0on: s.chatQ === 0, q1on: s.chatQ === 1,
      q0bg: s.chatQ === 0 ? '#F1F4FF' : '#FFFFFF', q0fg: s.chatQ === 0 ? '#1D2A66' : '#15171A', q0border: s.chatQ === 0 ? accent : '#CDD1D6',
      q1bg: s.chatQ === 1 ? '#F1F4FF' : '#FFFFFF', q1fg: s.chatQ === 1 ? '#1D2A66' : '#15171A', q1border: s.chatQ === 1 ? accent : '#CDD1D6',
      ask0: () => this.ask(0),
      ask1: () => this.ask(1)
    });
  }
  render() {
    return <HomeView v={this.renderVals()} />;
  }
}

export default HomeLogic;
